import axios from 'axios';
import { getAccessToken } from 'providers';
import { config } from 'config';
import * as rax from 'retry-axios';

const { apiUrl, retries } = config;
const myAxiosInstance = axios.create();

myAxiosInstance.defaults.raxConfig = {
  instance: myAxiosInstance,
  noResponseRetries: retries,
  retry: retries,
  backoffType: 'exponential',
  statusCodesToRetry: [[500, 599]],
};
rax.attach(myAxiosInstance);

const get = async <T>(endpoint: string): Promise<T> => {
  const token = await getAccessToken();

  const response = await myAxiosInstance.get<T>(`${apiUrl}/${endpoint}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return response.data;
};

const post = async <ResponseType, BodyType>(
  endpoint: string,
  body?: BodyType
): Promise<ResponseType> => {
  const token = await getAccessToken();

  const response = await myAxiosInstance.post<ResponseType>(`${apiUrl}/${endpoint}`, body, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return response.data;
};

export const api = {
  get,
  post,
};
